<template>
<div>
  <SKLFlightSort/>
     <div v-for="index in 3" :key="index"
    class="strip_all_tour_list wow fadeIn"
    data-wow-delay="0.1s"
    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeIn;"
  >
  
    <div class="post row">
      <div style="    padding-right: 5%;width: 20%;" class="mb-10 pt-10">
        <div class="custom-img-list img_list">
         <div class="avatar"></div>
          <div class="line"></div>
        </div>
      </div>
      <div style="width: 60%;" class="pt-10">
        <div class="row custom_tour_list_desc tour_list_desc">
          <div class="location-title mb-10 pt-10 col-2">
            <div class="line mb-10"></div>
            <div class="line"></div>
          </div>
          <div class="pt-10 col-8">
            <div class="line plane-line">
           
            </div>
          </div>
          <div class="location-title pt-10 col-2">
            <div class="line mb-10"></div>
            <div class="line"></div>
          </div>
        </div>
        <div class="line flight-time"  ></div>
      </div>
      <div  style="width: 20%;" class="pt-10">
        <div class="custom-price_list price_list">
          <div style="    padding-right: 20px;">
            
            <p>
              <label class="line selected-label"></label>
            </p>
             <label  class="line capacity-low" ></label>
            
          </div>
        </div>
      </div>

    </div>
  </div>
  <div style="padding: 0px 50% 0px 0px;" class="post row">
           <label style="width:5% !important "  v-for="index in 3" :key="index" class="line" ></label>
           
  </div>
</div>
 
</template>

<script>

import SKLFlightSort from "@/components/shared/Skeletons/SKLFlightSort";
export default {
  name: "SKL-Selected-Flight",
  components: {SKLFlightSort},
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>

.post {
  /* margin-bottom: 50px; */
  /* width: 220px; */
  /* height: 80px; */
}
.post .avatar {
        display: inline-table;
  /* float: right; */
  width: 50px;
  height: 50px;
  background-color: #ccc;
  border-radius: 25%;
  /* margin: 8px; */
  background-image: linear-gradient(
    90deg,
    #f4f4f4 0px,
    rgba(229, 229, 229, 0.8) 40px,
    #f4f4f4 80px
  );
  background-size: 600px;
  animation: shine-avatar 2s infinite ease-out;
}
.post .line {
 width: 100%;
  margin-left: 1%;
  float: left;
  height: 10px;
  margin-top: 12px;
  border-radius: 7px;
  background-image: linear-gradient(
    90deg,
    #f4f4f4 0px,
    rgba(229, 229, 229, 0.8) 40px,
    #f4f4f4 80px
  );
  background-size: 600px;
  animation: shine-lines 2s infinite ease-out;
}
.post .avatar + .line {
  margin-top: 11px;
      width: 100%;
}
.post .line ~ .line {
  background-color: #ddd;
}

@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%,
  100% {
    background-position: 140px;
  }
}
@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%,
  100% {
    background-position: 208px;
  }
}
</style>


